
export default {
  components: {},
  mixins: [],
  props: {
    item: {
      type: Object,
      default: null,
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    checkbox: true,
  }),
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    onClose() {
      this.$emit("close")
    },
  },
}
